export namespace MessageHelper {
    export const MESSAGE_TYPES = {
        ready: "ready",
        playable: "playable",
        play: "play",
        pause: "pause",
        seek: "seek",
        seeked: "seeked",
        duration: "duration",
        position: "position",
        volume: "volume",
        queueItem: "queueItem",
        playComplete: "playComplete",
        closePlayer: "closePlayer",
        minimizePlayer: "minimizePlayer",
        maximizePlayer: "maximizePlayer",
    }

    export const MESSAGE_BASE_IDENTIFIERS = {
        identifier: "Qplayer", // From QPlayer to other sites
        embeddedIdentifier: "Qplayer.Embedded", // From Embedded's sites. Only expose this to customers
        loaderIdentifier: "Qplayer.Loader", // From loaders to QPlayer
        editorIdentifier: "Qplayer.Editor" // From editor to QPlayer
    }

    export const sendMessageToLoader = ({ type, metadata, mediaId, scenarioId }: { type: string; metadata: any; mediaId: string, scenarioId?: string }) => {
        const messageData = {
            ...MESSAGE_BASE_DATA,
            type,
            mediaId,
            scenarioId,
            metadata
        }
        window.parent.postMessage(JSON.parse(JSON.stringify(messageData)), '*');
    }

    const MESSAGE_BASE_DATA = {
        identifier: MESSAGE_BASE_IDENTIFIERS.identifier,
    }

    export const sendMessage = ({ type, metadata, mediaId, scenarioId }: { type: string; metadata: any; mediaId: string, scenarioId?: string }) => {
        const messageData = {
            ...MESSAGE_BASE_DATA,
            type,
            mediaId,
            scenarioId,
            metadata
        }

        window.top && window.top.postMessage(JSON.parse(JSON.stringify(messageData)), '*');
        window.parent.postMessage(JSON.parse(JSON.stringify(messageData)), '*');
    }
}
